import React, { useState } from 'react';

export const VideoWithFallback = ({ src, poster, alt, className, testId, ...videoProps }) => {
  const [failed, setFailed] = useState(false);

  if (failed && poster) {
    return <img src={poster} alt={alt || ''} data-testid={testId} className={className} />;
  }

  return (
    <video
      data-testid={testId}
      className={className}
      poster={poster}
      autoPlay
      loop
      muted
      playsInline
      onError={() => setFailed(true)}
      src={src}
      {...videoProps}
    />
  );
};
